<div class="ra-filters">
    <div class="ra-filters__group">
        <span class="ra-filters__label" id="ra-job-filter-worklocation-label">Work location</span>
        <agu-segmented [Options]="WorkLocationSegments" [Value]="WorkLocation" GroupLabel="Work location" LabelledBy="ra-job-filter-worklocation-label" (ValueChange)="OnWorkLocationSegment($event)" />
    </div>
    <div class="ra-filters__group">
        <span class="ra-filters__label" id="ra-job-filter-region-label">Region</span>
        <agu-segmented [Options]="RegionSegments" [Value]="Region" GroupLabel="Region" LabelledBy="ra-job-filter-region-label" (ValueChange)="OnRegionSegment($event)" />
    </div>
    <div class="ra-filters__group">
        <label class="ra-filters__label" for="ra-job-filter-sector">Employer sector</label>
        <agu-select Id="ra-job-filter-sector" AriaLabel="Employer sector" [Options]="SectorSelect" [Value]="IndustryValue" (ValueChange)="OnIndustryChange($event)" />
    </div>
    <div class="ra-filters__group">
        <label class="ra-filters__label" for="ra-job-filter-area">Science area</label>
        <agu-select Id="ra-job-filter-area" AriaLabel="Science area" [Options]="AreaSelect" [Value]="SectionValue" (ValueChange)="OnSectionChange($event)" />
    </div>
    <!-- State only for United States, Country only for International (P/job-finder.html:1325-1326). -->
    @if (Region === 'us') {
        <div class="ra-filters__group">
            <label class="ra-filters__label" for="ra-job-filter-state">State</label>
            <agu-select Id="ra-job-filter-state" AriaLabel="State" [Options]="StateSelect" [Value]="StateValue" (ValueChange)="OnStateChange($event)" />
        </div>
    }
    @if (Region === 'international') {
        <div class="ra-filters__group">
            <label class="ra-filters__label" for="ra-job-filter-country">Country</label>
            <agu-select Id="ra-job-filter-country" AriaLabel="Country" [Options]="CountrySelect" [Value]="CountryValue" (ValueChange)="OnCountryChange($event)" />
        </div>
    }
    <!-- More filters (P/job-finder.html:1175-1179): opens by itself when a folded filter is set (:1517). "Visa sponsorship" (:1178) is not a ResearchJobFilterInput field in this build. -->
    <agu-rail-fold Tone="jobs" [FoldOpen]="FoldHasFilters">
        <div class="ra-filters__group">
            <label class="ra-filters__label" for="ra-job-filter-salary">Salary range</label>
            <agu-select Id="ra-job-filter-salary" AriaLabel="Salary range" [Options]="SalarySelect" [Value]="SalaryValue" (ValueChange)="OnSalarySelect($event)" />
        </div>
    </agu-rail-fold>
    <div class="ra-filters__group">
        <span class="ra-filters__label" id="ra-job-filter-show-label">Show</span>
        <div class="ra-filters__switches" role="group" aria-labelledby="ra-job-filter-show-label">
            <div class="ra-filters__switch-row">
                <mj-switch OnLabel="Saved only" OffLabel="Saved only" [ngModel]="ShowSavedOnly" (ngModelChange)="ShowSavedOnlyChange.emit($event)" />
            </div>
            <div class="ra-filters__switch-row">
                <mj-switch OnLabel="Posted this week" OffLabel="Posted this week" [ngModel]="PostedThisWeek" (ngModelChange)="PostedThisWeekChange.emit($event)" />
            </div>
            <div class="ra-filters__switch-row">
                <mj-switch OnLabel="Recommended only" OffLabel="Recommended only" [ngModel]="RecommendedOnly" (ngModelChange)="RecommendedOnlyChange.emit($event)" />
            </div>
        </div>
    </div>
</div>
